module.exports = __webpack_public_path__ + "src/assets/img/bg_vas_cocina.83ce3a0d.svg";